define(['jquery', "waypoints"],
    function($, waypoints) {
        var jumpNavFF = {
            $jumpLinkFF:'',
            $headerFF:'',
            $sectionFF:'',
            Init: function () {
                //declare vars
                this.$headerFF = $('.landing__nav');
                this.$jumpLinkFF = $('.landing__menu__link');
                this.$sectionIdFF = $('.page-wrapper').find('div[id]');


                if (jumpNavFF.$jumpLinkFF.length) {
                    jumpNavFF.$jumpLinkFF.on('click', jumpNavFF.jumpLinksFF);
                }
                if (jumpNavFF.$sectionIdFF.length) {
                    //log('test');
                    jumpNavFF.$sectionIdFF.each(function () {
                        var waypoint = new Waypoint({
                            element: $(this),
                            handler: function (direction) {
                                $('.landing__menu__link--active').removeClass('landing__menu__link--active');
                                $('.landing__menu__link[href="#'+this.element[0].id+'"]').addClass('landing__menu__link--active');
                                // log(this.element[0].id);
                                // log(this.element.id + 'triggers at ' + direction)
                            },
                            offset: 150
                        });
                    });
                }

                const navId = document.getElementById("ff-nav")
                const navLinks = navId && navId.getElementsByClassName('landing__menu__link')

                if (navId) {
                    navId.addEventListener("click", () => {
                        if (jumpNavFF.isTouchScreen() && navId.offsetLeft < 0) {
                            navId.style.left = 0;
                        }
                    })

                    for (i = 0; i < navLinks.length; i++) {
                        navLinks[i].addEventListener("click", () => {
                            if (jumpNavFF.isTouchScreen()) {
                                navId.style.left = 'calc(-100% + 11px)';
                            }
                        })
                    }

                    document.addEventListener('click', (e) => {
                        const isClickedOutsideNav = !e.composedPath().includes(navId)
                        if (isClickedOutsideNav && navId.offsetLeft === 0 && jumpNavFF.isTouchScreen()) {
                            navId.style.left = 'calc(-100% + 11px)';
                        }
                    })
                }


            },
            jumpScrollFF: function (scrollVar) {
                if (!scrollVar || scrollVar == '#' || scrollVar == '##') {
                    return;
                }
                var $where = $(scrollVar);
                var whereTo = $where.offset().top - 150;

                $('html, body').animate({
                    scrollTop: whereTo
                }, 500, 'swing');

                $where.attr('tabindex', -1).addClass('removetabindex').focus();
            },

            isTouchScreen: function () {
                return ('ontouchstart' in window) ||
                    (navigator.maxTouchPoints > 0) ||
                    (navigator.msMaxTouchPoints > 0);
            },

            jumpLinksFF: function () {
                var where = $(this).attr('href');

                jumpNavFF.jumpScrollFF(where);
            }
        }

        return jumpNavFF;
    }
);